// ------------------------------------------------------------------ //
// Inline handwritten accents on chapter/break slides: the standalone
// label words »Primjer« and »Odgovor« render in gold Caveat. Works on
// editor HTML (only text between tags is touched) and on plain i18n
// strings alike.
// ------------------------------------------------------------------ //

/* colon-terminated labels only: »primjer:« / »odgovor:« / »konačan
   odgovor:« (any capitalization), optionally with a short tail before
   the colon (»Primjer niza odgovora: …«). The colon is what marks a
   label — a colon-less »odgovor« mid-sentence stays ink. Croatian
   letters count as word characters, so »Primjerice:«/»Odgovoriti:« stay
   untouched. The rendered accent drops the colon and lowercases the
   label. */
const HAND_LABEL =
	/(?<![\p{L}\p{N}])((?:primjer|(?:konačan\s+)?odgovor)(?:\s+[\p{L}\p{N}]+){0,4})\s*:/giu;

const markText = (text: string): string =>
	text.replace(
		HAND_LABEL,
		(_match, label: string) =>
			`<span class="hand-gold-word">${label.toLowerCase()}</span>`
	);

/** Wrap the marked words in HTML from the editor. Tags and their
 *  attributes are left alone; only text between them is marked. */
export const markHandwrittenWords = (html: string): string =>
	html
		.split(/(<[^>]*>)/)
		.map((part) => (part.startsWith('<') ? part : markText(part)))
		.join('');

/** Same marking for a plain (non-HTML) string: escapes it first so it
 *  can be rendered via dangerouslySetInnerHTML. */
export const markHandwrittenWordsInText = (text: string): string =>
	markText(
		text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
	);
